import { Route } from '~/routes/subscription/checkout'

import { CheckoutForm } from '../components/checkout-form'
import { StripeCheckoutElements } from '../components/stripe-checkout-elements'

export const CheckoutPage = () => {
  const { clientSecret: clientSecretSearch, payment_intent_client_secret } = Route.useSearch()

  const clientSecret = clientSecretSearch ?? payment_intent_client_secret

  if (!clientSecret) return null

  return (
    <StripeCheckoutElements clientSecret={clientSecret}>
      <CheckoutForm />
    </StripeCheckoutElements>
  )
}
